// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-nav-bar-___nav-bar__container___B5cI7 {
  background-color: var(--gray-darker);
  border-color: #080808;
  box-shadow: 0px 2px 5px rgba(100, 100, 100, 0.7);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1;
}

.src-components-nav-bar-___nav-bar__navbar___MN7Ni {
  align-items: baseline;
  color: var(--gray-lighter);
  display: flex;
  justify-content: space-between;
  padding: var(--container-padding);
  width: 100%;
}

.src-components-nav-bar-___nav-bar__nav-link___ZRDMu {
  border: 1px solid #666;
  border-radius: 2px;
  display: inline-block;
  margin: 0.5em;
  padding: 0.5em;
}

.src-components-nav-bar-___nav-bar__nav-link___ZRDMu,
.src-components-nav-bar-___nav-bar__nav-link___ZRDMu:active,
.src-components-nav-bar-___nav-bar__nav-link___ZRDMu:focus,
.src-components-nav-bar-___nav-bar__nav-link___ZRDMu:hover {
  color: var(--gray-lighter);
  text-decoration: none;
}

.src-components-nav-bar-___nav-bar__nav-link-active___umW0M {
  background-color: var(--brand-primary);
}

.src-components-nav-bar-___nav-bar__nav-list___RzSUF {
  align-items: center;
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.src-components-nav-bar-___nav-bar__brand___JWTtO {
  display: block;
  font-size: 1.4em;
  font-weight: bold;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.src-components-nav-bar-___nav-bar__brand___JWTtO,
.src-components-nav-bar-___nav-bar__brand___JWTtO:active,
.src-components-nav-bar-___nav-bar__brand___JWTtO:focus,
.src-components-nav-bar-___nav-bar__brand___JWTtO:hover {
  color: white;
  text-decoration: none;
}

.src-components-nav-bar-___nav-bar__auth-status___zyfN8 {
  padding: var(--container-padding);
}

.src-components-nav-bar-___nav-bar__auth-btn___maZn5 {
  color: #9d9d9d;
  padding: 0;
  vertical-align: baseline;
}

.src-components-nav-bar-___nav-bar__auth-btn___maZn5:active,
.src-components-nav-bar-___nav-bar__auth-btn___maZn5:hover {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/nav-bar/nav-bar.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,gDAAgD;EAChD,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,cAAc;AAChB;;AAEA;;;;EAIE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;EAIE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;AACd","sourcesContent":[".container {\n  background-color: var(--gray-darker);\n  border-color: #080808;\n  box-shadow: 0px 2px 5px rgba(100, 100, 100, 0.7);\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n}\n\n.navbar {\n  align-items: baseline;\n  color: var(--gray-lighter);\n  display: flex;\n  justify-content: space-between;\n  padding: var(--container-padding);\n  width: 100%;\n}\n\n.nav-link {\n  border: 1px solid #666;\n  border-radius: 2px;\n  display: inline-block;\n  margin: 0.5em;\n  padding: 0.5em;\n}\n\n.nav-link,\n.nav-link:active,\n.nav-link:focus,\n.nav-link:hover {\n  color: var(--gray-lighter);\n  text-decoration: none;\n}\n\n.nav-link-active {\n  background-color: var(--brand-primary);\n}\n\n.nav-list {\n  align-items: center;\n  display: flex;\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.brand {\n  display: block;\n  font-size: 1.4em;\n  font-weight: bold;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.brand,\n.brand:active,\n.brand:focus,\n.brand:hover {\n  color: white;\n  text-decoration: none;\n}\n\n.auth-status {\n  padding: var(--container-padding);\n}\n\n.auth-btn {\n  color: #9d9d9d;\n  padding: 0;\n  vertical-align: baseline;\n}\n\n.auth-btn:active,\n.auth-btn:hover {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `src-components-nav-bar-___nav-bar__container___B5cI7`,
	"navbar": `src-components-nav-bar-___nav-bar__navbar___MN7Ni`,
	"nav-link": `src-components-nav-bar-___nav-bar__nav-link___ZRDMu`,
	"navLink": `src-components-nav-bar-___nav-bar__nav-link___ZRDMu`,
	"nav-link-active": `src-components-nav-bar-___nav-bar__nav-link-active___umW0M`,
	"navLinkActive": `src-components-nav-bar-___nav-bar__nav-link-active___umW0M`,
	"nav-list": `src-components-nav-bar-___nav-bar__nav-list___RzSUF`,
	"navList": `src-components-nav-bar-___nav-bar__nav-list___RzSUF`,
	"brand": `src-components-nav-bar-___nav-bar__brand___JWTtO`,
	"auth-status": `src-components-nav-bar-___nav-bar__auth-status___zyfN8`,
	"authStatus": `src-components-nav-bar-___nav-bar__auth-status___zyfN8`,
	"auth-btn": `src-components-nav-bar-___nav-bar__auth-btn___maZn5`,
	"authBtn": `src-components-nav-bar-___nav-bar__auth-btn___maZn5`
};
export default ___CSS_LOADER_EXPORT___;
